var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.lW=require("crc-32");module.exports=$CLJS.lW;